import { MessageCircle, Phone, MapPin } from "lucide-react";
import { LOGO_URL, CONTACT } from "@/data/services";
import { TID } from "@/constants/testIds/site";

export default function Footer() {
  return (
    <footer
      data-testid={TID.footer.section}
      className="relative pt-24 pb-10 px-6 md:px-10 border-t border-white/10 overflow-hidden"
    >
      {/* Giant CTA text */}
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-20">
          <div className="text-[11px] uppercase tracking-[0.4em] text-white/50 mb-4">
            <span className="text-gold">✦</span> Votre succès digital
          </div>
          <div className="font-display text-[16vw] md:text-[10vw] leading-[0.85] tracking-tighter text-silver-gradient">
            Digital
          </div>
          <div className="font-display text-[16vw] md:text-[10vw] leading-[0.85] tracking-tighter text-gold-gradient italic -mt-2">
            Création Promo.
          </div>
        </div>

        <div className="grid md:grid-cols-12 gap-10 border-t border-white/10 pt-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-md overflow-hidden ring-1 ring-white/10">
                <img
                  src={LOGO_URL}
                  alt="logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="font-display text-white text-lg">
                  Digital Création Promo
                </div>
                <div className="text-white/45 text-[10px] uppercase tracking-[0.35em]">
                  Abidjan · Côte d&apos;Ivoire
                </div>
              </div>
            </div>
            <p className="text-white/55 text-sm leading-relaxed max-w-md">
              Votre partenaire digital pour Facebook, TikTok et l&apos;identité de
              marque. Prix imbattables, livraison rapide, résultats mesurables.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.35em] text-white/40 mb-4">
              Services
            </div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li>Packs Facebook</li>
              <li>Packs TikTok</li>
              <li>Design & Logo</li>
              <li>Publicité en ligne</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.35em] text-white/40 mb-4">
              Contact
            </div>
            <div className="space-y-3">
              <a
                href={`https://wa.me/${CONTACT.whatsappRaw}`}
                target="_blank"
                rel="noreferrer"
                data-testid={TID.footer.whatsapp}
                className="flex items-center gap-3 text-white/80 hover:text-[#d4af37] transition-colors"
              >
                <MessageCircle size={16} />
                <span>{CONTACT.whatsapp}</span>
              </a>
              <a
                href={`tel:${CONTACT.infolineRaw}`}
                data-testid={TID.footer.call}
                className="flex items-center gap-3 text-white/80 hover:text-[#d4af37] transition-colors"
              >
                <Phone size={16} />
                <span>{CONTACT.infoline}</span>
              </a>
              <div className="flex items-center gap-3 text-white/80">
                <span className="text-[#FF7900] text-xs font-bold uppercase tracking-widest">
                  OM
                </span>
                <span className="text-sm">{CONTACT.orangeMoney}</span>
              </div>
              <div className="flex items-center gap-3 text-white/80">
                <span className="text-[#FFCC00] text-xs font-bold uppercase tracking-widest">
                  MTN
                </span>
                <span className="text-sm">{CONTACT.mtnMoney}</span>
              </div>
              <div className="flex items-center gap-3 text-white/60 text-sm">
                <MapPin size={16} />
                <span>Abidjan, Côte d&apos;Ivoire</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-white/40 text-xs">
          <div>
            © {new Date().getFullYear()} Digital Création Promo — Tous droits
            réservés.
          </div>
          <div className="uppercase tracking-[0.3em]">
            #pourtoi · #digital · #monetisation
          </div>
        </div>
      </div>
    </footer>
  );
}
